export default "__VITE_ASSET__CRii7wje__"